// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /oauth/provider-config-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeOauthProviderConfigGetBody,
  typeOauthProviderConfigGetOutput200,
} from "../../sdk/oauth/postOauthProviderConfigGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildOauthProviderConfigGetQueryKey(
  payload: typeOauthProviderConfigGetBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:oauth:oauthProviderConfigGet",
    "svc:auth-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeOauthProviderConfigGetOutput200,
    unknown,
    typeOauthProviderConfigGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useOauthProviderConfigGet(
  payload: typeOauthProviderConfigGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildOauthProviderConfigGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postOauthProviderConfigGet(payload),
    ...resolvedOptions,
  });
}
